import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React from "react";
import { NameAndAddress } from "../../company/detail/components/models";
import { AddressInnerForm } from "./AddressInnerForm";


interface Props {
  address: NameAndAddress
  onChange: (value: NameAndAddress) => void
  submit: () => void
  isSaving: boolean
  renderIsPostalAddressCheckbox?: () => React.ReactNode;
}

export const AddressWithNameInnerForm = (props: Props) => {
  return <AddressInnerForm
    submit={props.submit}
    isSaving={props.isSaving}
    address={props.address}
    onChange={props.onChange}
    fields={[
      {
        key: "companyName",
        label: RESX.GeneralLabels.Name,
        renderEditNew: () => {
          return <RequiredTextInput
            focusOnMount
            value={props.address.companyName}
            maxLength={serverReference.constants.company.maxNameLength}
            validatorKey={"visiting_companyName"}
            onChange={(value) => props.onChange({
              ...props.address,
              companyName: value
            })}
          />
        }
      }
    ]}
    fieldsBottom={[
      {
        key: "isPostalAddress",
        hideLabel: true,
        hidden: !props.renderIsPostalAddressCheckbox,
        label: "",
        renderEditNew: props.renderIsPostalAddressCheckbox,
      }
    ]}
  />
}